import { render } from "./StudentEvaluation.vue?vue&type=template&id=54559da2"
import script from "./StudentEvaluation.vue?vue&type=script&lang=js"
export * from "./StudentEvaluation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__